module.exports = __webpack_public_path__ + "media/file_icons/one-note-be956d72.svg";